import React, { useContext, useState } from "react";
import { Context } from "../../../../config/store";

const Status = ({row:{mandate_status}}) => {
    return (
        <span style={{ fontSize: '12px', fontWeight: '600', color: (mandate_status ? 'green' : 'red') }}>
            {mandate_status == 1 ? ' SUCCESS' : (mandate_status == 0 ? ' FAILED' : '')}
        </span>
    );
};

export default Status;
